export class ApiConnectionData {
  apiUrl: string;
  apiKey: string;
}
